import { createContext, useState } from 'react';

export const SupOrgDatesContext = createContext();

export function SupOrgDatesProvider({ children }) {
    const [dates, setDates] = useState([]);
    const [upComing, setUpComing] = useState(true);

    return (
        <SupOrgDatesContext.Provider value={{ dates, setDates, upComing, setUpComing }}>
            {children}
        </SupOrgDatesContext.Provider>
    );
}
